//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UserClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type UserGetUserQueryParameters = {
  id: string ;
}

export type UserUpdateUserQueryParameters = {
  id: string ;
}

export type UserDeleteUserQueryParameters = {
  id: string ;
}

export type UserGetListUserQueryParameters = {
  filter?: string | undefined ;
  sorting?: string | undefined ;
  skipCount?: number | undefined ;
  maxResultCount?: number | undefined ;
  extraProperties?: { [key: string]: any; } | undefined ;
}

export type UserFindByIdUserQueryParameters = {
  id: string ;
}

export type UserGetRolesUserQueryParameters = {
  id: string ;
}

export type UserUpdateRolesUserQueryParameters = {
  id: string ;
}

export type UserFindByUsernameUserQueryParameters = {
  userName: string ;
}

export type UserFindByEmailUserQueryParameters = {
  email: string ;
}

export function userGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let userGetDefaultOptions: Omit<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryFn'>> = {
};
export function getUserGetDefaultOptions() {
  return userGetDefaultOptions;
};
export function setUserGetDefaultOptions(options: typeof userGetDefaultOptions) {
  userGetDefaultOptions = options;
}

export function userGetQueryKey(id: string): QueryKey;
export function userGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as UserGetUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'userGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'userGet',
        ...params
      ]);
  }
}
export function __userGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.userGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function useUserGetQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(dto: UserGetUserQueryParameters, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useUserGetQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useUserGetQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IdentityUserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as UserGetUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.IdentityUserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __userGet(context, axiosConfig) : __userGet,
    queryKey: userGetQueryKey(id),
    ...userGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setUserGetData(queryClient: QueryClient, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto, id: string) {
  queryClient.setQueryData(userGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setUserGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function userUpdateUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function userUpdateMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'userUpdate',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useUserUpdateMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.IdentityUserDto, unknown, Types.IdentityUserUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IdentityUserDto, unknown, Types.IdentityUserUpdateDto, TContext> {
  const key = userUpdateMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.IdentityUserUpdateDto) => Client.userUpdate(id, body),
    mutationKey: key,
  });
}
  
type UserUpdate__MutationParameters = UserUpdateUserQueryParameters & {
  body: Types.IdentityUserUpdateDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useUserUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.IdentityUserDto, unknown, UserUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UserUpdateUserQueryParameters}): UseMutationResult<Types.IdentityUserDto, unknown, UserUpdate__MutationParameters, TContext> {
  const key = userUpdateMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UserUpdate__MutationParameters) => Client.userUpdate(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function userDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function userDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'userDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useUserDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = userDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.userDelete(id),
    mutationKey: key,
  });
}
  
type UserDelete__MutationParameters = UserDeleteUserQueryParameters

/**
 * @return OK
 */
export function useUserDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, UserDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UserDeleteUserQueryParameters}): UseMutationResult<void, unknown, UserDelete__MutationParameters, TContext> {
  const key = userDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UserDelete__MutationParameters) => Client.userDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function userGetListUrl(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined): string {
  let url_ = getBaseUrl() + "/api/identity/users?";
if (filter === null)
    throw new Error("The parameter 'filter' cannot be null.");
else if (filter !== undefined)
    url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
if (sorting === null)
    throw new Error("The parameter 'sorting' cannot be null.");
else if (sorting !== undefined)
    url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
if (skipCount === null)
    throw new Error("The parameter 'skipCount' cannot be null.");
else if (skipCount !== undefined)
    url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
if (extraProperties === null)
    throw new Error("The parameter 'extraProperties' cannot be null.");
else if (extraProperties !== undefined)
    extraProperties && Object.keys(extraProperties).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + extraProperties[key]) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let userGetListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityUserDto, unknown, Types.PagedResultDtoOfIdentityUserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultDtoOfIdentityUserDto, unknown, Types.PagedResultDtoOfIdentityUserDto>, 'queryFn'>> = {
};
export function getUserGetListDefaultOptions() {
  return userGetListDefaultOptions;
};
export function setUserGetListDefaultOptions(options: typeof userGetListDefaultOptions) {
  userGetListDefaultOptions = options;
}

export function userGetListQueryKey(dto: UserGetListUserQueryParameters): QueryKey;
export function userGetListQueryKey(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined): QueryKey;
export function userGetListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { filter, sorting, skipCount, maxResultCount, extraProperties,  } = params[0] as UserGetListUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'userGetList',
        filter as any,
        sorting as any,
        skipCount as any,
        maxResultCount as any,
        extraProperties as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'userGetList',
        ...params
      ]);
  }
}
export function __userGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.userGetList(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as number | undefined,       context.queryKey[6] as { [key: string]: any; } | undefined,axiosConfig    );
}

export function useUserGetListQuery<TSelectData = Types.PagedResultDtoOfIdentityUserDto, TError = unknown>(dto: UserGetListUserQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @param extraProperties (optional) 
 * @return OK
 */
export function useUserGetListQuery<TSelectData = Types.PagedResultDtoOfIdentityUserDto, TError = unknown>(filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useUserGetListQuery<TSelectData = Types.PagedResultDtoOfIdentityUserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultDtoOfIdentityUserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let filter: any = undefined;
  let sorting: any = undefined;
  let skipCount: any = undefined;
  let maxResultCount: any = undefined;
  let extraProperties: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ filter, sorting, skipCount, maxResultCount, extraProperties,  } = params[0] as UserGetListUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [filter, sorting, skipCount, maxResultCount, extraProperties, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultDtoOfIdentityUserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __userGetList(context, axiosConfig) : __userGetList,
    queryKey: userGetListQueryKey(filter, sorting, skipCount, maxResultCount, extraProperties),
    ...userGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultDtoOfIdentityUserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @param extraProperties (optional) 
 * @return OK
 */
export function setUserGetListData(queryClient: QueryClient, updater: (data: Types.PagedResultDtoOfIdentityUserDto | undefined) => Types.PagedResultDtoOfIdentityUserDto, filter?: string | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, extraProperties?: { [key: string]: any; } | undefined) {
  queryClient.setQueryData(userGetListQueryKey(filter, sorting, skipCount, maxResultCount, extraProperties),
    updater
  );
}

/**
 * @param filter (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @param extraProperties (optional) 
 * @return OK
 */
export function setUserGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultDtoOfIdentityUserDto | undefined) => Types.PagedResultDtoOfIdentityUserDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function userCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/identity/users";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function userCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'userCreate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useUserCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.IdentityUserDto, unknown, Types.IdentityUserCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.IdentityUserDto, unknown, Types.IdentityUserCreateDto, TContext> {
  const key = userCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.IdentityUserCreateDto) => Client.userCreate(body),
    mutationKey: key,
  });
}
  
export function userFindByIdUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/by-id/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let userFindByIdDefaultOptions: Omit<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryFn'>> = {
};
export function getUserFindByIdDefaultOptions() {
  return userFindByIdDefaultOptions;
};
export function setUserFindByIdDefaultOptions(options: typeof userFindByIdDefaultOptions) {
  userFindByIdDefaultOptions = options;
}

export function userFindByIdQueryKey(id: string): QueryKey;
export function userFindByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as UserFindByIdUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'userFindById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'userFindById',
        ...params
      ]);
  }
}
export function __userFindById(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.userFindById(
      context.queryKey[2] as string,axiosConfig    );
}

export function useUserFindByIdQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(dto: UserFindByIdUserQueryParameters, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useUserFindByIdQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useUserFindByIdQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IdentityUserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as UserFindByIdUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.IdentityUserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __userFindById(context, axiosConfig) : __userFindById,
    queryKey: userFindByIdQueryKey(id),
    ...userFindByIdDefaultOptions as unknown as Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setUserFindByIdData(queryClient: QueryClient, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto, id: string) {
  queryClient.setQueryData(userFindByIdQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setUserFindByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function userGetRolesUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/{id}/roles";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let userGetRolesDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, unknown, Types.ListResultDtoOfIdentityRoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, unknown, Types.ListResultDtoOfIdentityRoleDto>, 'queryFn'>> = {
};
export function getUserGetRolesDefaultOptions() {
  return userGetRolesDefaultOptions;
};
export function setUserGetRolesDefaultOptions(options: typeof userGetRolesDefaultOptions) {
  userGetRolesDefaultOptions = options;
}

export function userGetRolesQueryKey(id: string): QueryKey;
export function userGetRolesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as UserGetRolesUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'userGetRoles',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'userGetRoles',
        ...params
      ]);
  }
}
export function __userGetRoles(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.userGetRoles(
      context.queryKey[2] as string,axiosConfig    );
}

export function useUserGetRolesQuery<TSelectData = Types.ListResultDtoOfIdentityRoleDto, TError = unknown>(dto: UserGetRolesUserQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useUserGetRolesQuery<TSelectData = Types.ListResultDtoOfIdentityRoleDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useUserGetRolesQuery<TSelectData = Types.ListResultDtoOfIdentityRoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as UserGetRolesUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __userGetRoles(context, axiosConfig) : __userGetRoles,
    queryKey: userGetRolesQueryKey(id),
    ...userGetRolesDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setUserGetRolesData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfIdentityRoleDto | undefined) => Types.ListResultDtoOfIdentityRoleDto, id: string) {
  queryClient.setQueryData(userGetRolesQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setUserGetRolesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfIdentityRoleDto | undefined) => Types.ListResultDtoOfIdentityRoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function userUpdateRolesUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/{id}/roles";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function userUpdateRolesMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'userUpdateRoles',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useUserUpdateRolesMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, Types.IdentityUserUpdateRolesDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.IdentityUserUpdateRolesDto, TContext> {
  const key = userUpdateRolesMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.IdentityUserUpdateRolesDto) => Client.userUpdateRoles(id, body),
    mutationKey: key,
  });
}
  
type UserUpdateRoles__MutationParameters = UserUpdateRolesUserQueryParameters & {
  body: Types.IdentityUserUpdateRolesDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useUserUpdateRolesMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, UserUpdateRoles__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UserUpdateRolesUserQueryParameters}): UseMutationResult<void, unknown, UserUpdateRoles__MutationParameters, TContext> {
  const key = userUpdateRolesMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UserUpdateRoles__MutationParameters) => Client.userUpdateRoles(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function userGetAssignableRolesUrl(): string {
  let url_ = getBaseUrl() + "/api/identity/users/assignable-roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let userGetAssignableRolesDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, unknown, Types.ListResultDtoOfIdentityRoleDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, unknown, Types.ListResultDtoOfIdentityRoleDto>, 'queryFn'>> = {
};
export function getUserGetAssignableRolesDefaultOptions() {
  return userGetAssignableRolesDefaultOptions;
};
export function setUserGetAssignableRolesDefaultOptions(options: typeof userGetAssignableRolesDefaultOptions) {
  userGetAssignableRolesDefaultOptions = options;
}

export function userGetAssignableRolesQueryKey(): QueryKey;
export function userGetAssignableRolesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UserClient',
      'userGetAssignableRoles',
    ]);
}
export function __userGetAssignableRoles(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.userGetAssignableRoles(
axiosConfig    );
}

/**
 * @return OK
 */
export function useUserGetAssignableRolesQuery<TSelectData = Types.ListResultDtoOfIdentityRoleDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useUserGetAssignableRolesQuery<TSelectData = Types.ListResultDtoOfIdentityRoleDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __userGetAssignableRoles(context, axiosConfig) : __userGetAssignableRoles,
    queryKey: userGetAssignableRolesQueryKey(),
    ...userGetAssignableRolesDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfIdentityRoleDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setUserGetAssignableRolesData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfIdentityRoleDto | undefined) => Types.ListResultDtoOfIdentityRoleDto, ) {
  queryClient.setQueryData(userGetAssignableRolesQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setUserGetAssignableRolesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfIdentityRoleDto | undefined) => Types.ListResultDtoOfIdentityRoleDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function userFindByUsernameUrl(userName: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/by-username/{userName}";
if (userName === undefined || userName === null)
  throw new Error("The parameter 'userName' must be defined.");
url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let userFindByUsernameDefaultOptions: Omit<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryFn'>> = {
};
export function getUserFindByUsernameDefaultOptions() {
  return userFindByUsernameDefaultOptions;
};
export function setUserFindByUsernameDefaultOptions(options: typeof userFindByUsernameDefaultOptions) {
  userFindByUsernameDefaultOptions = options;
}

export function userFindByUsernameQueryKey(userName: string): QueryKey;
export function userFindByUsernameQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { userName,  } = params[0] as UserFindByUsernameUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'userFindByUsername',
        userName as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'userFindByUsername',
        ...params
      ]);
  }
}
export function __userFindByUsername(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.userFindByUsername(
      context.queryKey[2] as string,axiosConfig    );
}

export function useUserFindByUsernameQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(dto: UserFindByUsernameUserQueryParameters, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useUserFindByUsernameQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(userName: string, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useUserFindByUsernameQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IdentityUserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let userName: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ userName,  } = params[0] as UserFindByUsernameUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [userName, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.IdentityUserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __userFindByUsername(context, axiosConfig) : __userFindByUsername,
    queryKey: userFindByUsernameQueryKey(userName),
    ...userFindByUsernameDefaultOptions as unknown as Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setUserFindByUsernameData(queryClient: QueryClient, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto, userName: string) {
  queryClient.setQueryData(userFindByUsernameQueryKey(userName),
    updater
  );
}

/**
 * @return OK
 */
export function setUserFindByUsernameDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function userFindByEmailUrl(email: string): string {
  let url_ = getBaseUrl() + "/api/identity/users/by-email/{email}";
if (email === undefined || email === null)
  throw new Error("The parameter 'email' must be defined.");
url_ = url_.replace("{email}", encodeURIComponent("" + email));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let userFindByEmailDefaultOptions: Omit<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.IdentityUserDto, unknown, Types.IdentityUserDto>, 'queryFn'>> = {
};
export function getUserFindByEmailDefaultOptions() {
  return userFindByEmailDefaultOptions;
};
export function setUserFindByEmailDefaultOptions(options: typeof userFindByEmailDefaultOptions) {
  userFindByEmailDefaultOptions = options;
}

export function userFindByEmailQueryKey(email: string): QueryKey;
export function userFindByEmailQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { email,  } = params[0] as UserFindByEmailUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'userFindByEmail',
        email as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'userFindByEmail',
        ...params
      ]);
  }
}
export function __userFindByEmail(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.userFindByEmail(
      context.queryKey[2] as string,axiosConfig    );
}

export function useUserFindByEmailQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(dto: UserFindByEmailUserQueryParameters, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useUserFindByEmailQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(email: string, options?: Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useUserFindByEmailQuery<TSelectData = Types.IdentityUserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IdentityUserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let email: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ email,  } = params[0] as UserFindByEmailUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [email, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.IdentityUserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __userFindByEmail(context, axiosConfig) : __userFindByEmail,
    queryKey: userFindByEmailQueryKey(email),
    ...userFindByEmailDefaultOptions as unknown as Omit<UseQueryOptions<Types.IdentityUserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setUserFindByEmailData(queryClient: QueryClient, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto, email: string) {
  queryClient.setQueryData(userFindByEmailQueryKey(email),
    updater
  );
}

/**
 * @return OK
 */
export function setUserFindByEmailDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IdentityUserDto | undefined) => Types.IdentityUserDto) {
  queryClient.setQueryData(queryKey, updater);
}